import { defineMessages } from 'react-intl';

export const i18n: {
	atlassianSupportLink: {
		id: string;
		description: string;
		defaultMessage: string;
	};
} = defineMessages({
	atlassianSupportLink: {
		id: 'error-boundary.description.support-link',
		description: 'The text of the link which will lead the user to the Atlassian Support web site',
		defaultMessage: 'Atlassian Support',
	},
});
